import React from "react";
import KogCheckBoxControlled from "@/main/components/shared/checkbox/checkBoxControlled";
import { useFormContext, useWatch } from "react-hook-form";
import { QuoteSupplierItemPartResponse } from "@/main/models/response";
import { isNullUndefinedEmpty } from "@/main/services/utils";
import { ICreateAnswerForm } from "../../../interfaceCreateAnswer";
import LockedNotQuoteCheckbox from "../../../components/lockedNotQuoteCheckbox/lockedNotQuoteCheckbox";

interface INotQuoteCheckboxProps {
	fieldPrefix: string;
	fieldArrayName: "pendingItems" | "answeredItems";
	hasReadOnly?: boolean;
	setAllSelected: React.Dispatch<React.SetStateAction<boolean>>;
	row?: QuoteSupplierItemPartResponse;
	lockedTooltipMessage?: string;
}

export default function ColumnNotQuote({
	fieldPrefix,
	fieldArrayName,
	hasReadOnly,
	setAllSelected,
	row,
	lockedTooltipMessage,
}: INotQuoteCheckboxProps) {
	const { control, setValue, clearErrors, getValues } = useFormContext<ICreateAnswerForm>();

	const watcherNagsLoading = useWatch({
		control,
		name: `${fieldPrefix}.isNagsLoading` as const,
		defaultValue: false,
	});

	function validateFields(checked: boolean) {
		if (checked) {
			const fieldToClear = [
				"answeredPrice",
				"stock",
				"partBrandName",
				"partNumber",
				"warehouseName",
				"height",
				"width",
				"depth",
				"pickupTime",
				"weight",
			];
			clearErrors(fieldToClear.map((field) => `${fieldPrefix}.${field}`) as any);
		}
	}

	function handleSelectAllNotQuote() {
		const items = getValues(fieldArrayName);
		const checkedCount = items.filter((item) => item.notQuote).length;
		setAllSelected(checkedCount === items.length && items.length > 0);
	}

	const idElementCreateAnswerNotQuote = `id-createAnswer-checkBox-notQuote-${row?.idUnique || row?.guidQuoteSupplierItem || fieldPrefix}`;

	if (lockedTooltipMessage) {
		return (
			<LockedNotQuoteCheckbox
				id={idElementCreateAnswerNotQuote}
				checked={false}
				tooltipMessage={lockedTooltipMessage}
			/>
		);
	}

	return (
		<KogCheckBoxControlled
			id={idElementCreateAnswerNotQuote}
			label=""
			nameCustom={`${fieldPrefix}.notQuote`}
			control={control}
			disabled={hasReadOnly || watcherNagsLoading}
			onChangeCustom={(checked: boolean) => {
				validateFields(checked);

				if (checked) {
					setValue(`${fieldPrefix}.backOrder` as any, false);
					handleSelectAllNotQuote();
				}

				if (!checked) {
					setAllSelected(checked);
					setValue(`${fieldPrefix}.reason` as any, null);
					setValue(`${fieldPrefix}.observation` as any, "");

					const isNagsLocked = getValues(`${fieldPrefix}.isNagsLocked` as any);
					const nagsPrice = getValues(`${fieldPrefix}.nagsPrice` as any);
					if (isNagsLocked && !isNullUndefinedEmpty(nagsPrice)) {
						setValue(`${fieldPrefix}.answeredPrice` as any, nagsPrice);
					}
				}
			}}
		/>
	);
}
